import styled from 'styled-components';
export const FooterElement = styled.footer `
  height: 45px;
  background-color: #333333;
  margin-top: 25px;
  width: 100%;
`;
export const FooterContainer = styled.div `
  display: flex;
  float: right;
  margin-right: 28px;
`;
